import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./PartnerApply.css";
import { db } from "../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

export default function PartnerApply() {
  /* ─────────── Local State ─────────── */
  const [form, setForm] = useState({
    organization: "",
    contactName: "",
    email: "",
    phone: "",
    partnershipType: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  /* ─────────── Handlers ─────────── */
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    /* 1. 生成 slug + 文档对象 */
    const slug = form.organization.toLowerCase().replace(/\s+/g, "-");
    const newDoc = {
      name: form.organization,
      description: form.message || "—",
      logo: "",
      views: 0,
      status: "proposed",
      contactName: form.contactName,
      email: form.email,
      phone: form.phone,
      partnershipType: form.partnershipType,
      createdAt: serverTimestamp(),
    };

    /* 2. 写入 /partners/{slug} */
    try {
      await setDoc(doc(db, "partners", slug), newDoc);
      /* 3. 跳回列表；列表页通过 onSnapshot 自动刷新 */
      navigate("/partners");
    } catch (err) {
      console.error("Firestore write failed:", err);
      alert("Failed to submit, please retry.");
      setSending(false);
    }
  };

  /* ─────────── UI ─────────── */
  return (
    <div className="apply-container">
      <Link to="/partners" className="apply-back-btn">
        ← Back
      </Link>

      <h1>Partner with Lex</h1>
      <p className="apply-tagline">
        Tell us about you or your organization and how you’d like to collaborate.
      </p>

      <form className="apply-form" onSubmit={handleSubmit}>
        {/* —— 表单字段 —— */}
        <label>
          Organization / Company
          <input
            name="organization"
            value={form.organization}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Contact Name
          <input
            name="contactName"
            value={form.contactName}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Email
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Phone (optional)
          <input name="phone" value={form.phone} onChange={handleChange} />
        </label>

        <label>
          Partnership Type
          <select
            name="partnershipType"
            value={form.partnershipType}
            onChange={handleChange}
            required
          >
            <option value="">Select…</option>
            <option value="Technology">Technology Integration</option>
            <option value="Channel">Channel / Reseller</option>
            <option value="Research">Research Collaboration</option>
            <option value="Marketing">Co-Marketing</option>
            <option value="Others">Others</option>
          </select>
        </label>

        <label>
          Message / Proposal
          <textarea
            name="message"
            rows={4}
            value={form.message}
            onChange={handleChange}
          />
        </label>

        <button type="submit" className="apply-submit" disabled={sending}>
          {sending ? "Submitting…" : "Submit"}
        </button>
      </form>
    </div>
  );
}
